import React from "react";
import styled from "styled-components";
import FullButton from "../Buttons/FullButton";
import { Link } from "react-router-dom";

const CallToAction = () => {
  return (
    <Wrapper>
      <div className="container">
        <Content>
          <h2>Ready to simplify your church operations?</h2>
          <p>Start your 14-day free trial or request a live demo today. No credit card required.</p>
          <ButtonRow>
            <a href="https://churchsuite.roshtech.co.ke/signup" target="_blank" rel="noopener noreferrer">
              <FullButton title="Start Free Trial" />
            </a>
            <a href="/#demo">
              <FullButton title="Request a Demo" outline />
            </a>
          </ButtonRow>
        </Content>
      </div>
    </Wrapper>
  );
};

export default CallToAction;

const Wrapper = styled.section`
  background: linear-gradient(135deg, #f97316, #f59e0b);
  padding: 60px 0;
  text-align: center;
  color: #fff;
`;

const Content = styled.div`
  max-width: 700px;
  margin: auto;

  h2 {
    font-size: 32px;
    font-weight: 800;
    margin-bottom: 15px;
  }

  p {
    font-size: 16px;
    margin-bottom: 30px;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
`;
